import * as React from 'react'
import FlatCard from 'ui/atoms/FlatCard'
import Space from 'ui/atoms/Space'

import BillingDetails from './components/BillingDetails'
import CurrentPlan from './components/CurrentPlan'
import Invoices from './components/Invoices'
import PaymentMethod from './components/PaymentMethod'

function BillingInfo({ subscription }) {
  return (
    <FlatCard>
      <Space className="p-2" size="large">
        <PaymentMethod />
        <CurrentPlan />
        <BillingDetails />
        <Invoices />
      </Space>
    </FlatCard>
  )
}

export default BillingInfo
